var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar simple-nav p-0"},[_c('b-link',{attrs:{"to":{ name:'start-page' }}},[_c('b-img',{attrs:{"src":require('@/assets/custom-images/vacina-sesi-logo-azul.svg')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }